import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={'100%'}
    height={undefined}
    viewBox="0 0 42 53"
    fill="#9B998F"
    className="hover:fill-[#2AD2C9] ease-in-out duration-300"
    {...props}
  >
    <path
      fill=""
      d="M25.035 4.816 16.692 0 0 9.639l8.35 4.816 16.685-9.639ZM8.35 33.727l8.342-4.823 8.343-4.816-8.343-4.822-8.343 4.822L0 28.904l8.35 4.823ZM8.35 35.332 0 30.516v17.667l8.35 4.816V35.332ZM9.953 52.073l6.74-3.887 8.343-4.822h-.007l.013-.007V33.72L16.7 38.535l-6.746 3.893v9.645ZM41.728 14.457 33.39 9.64h-.006v9.632l8.343-4.816ZM16.7 11.246l8.336-4.816.006 16.07-8.343-4.816v-6.438ZM41.734 16.063l-8.35 4.809v27.312l8.344-4.822.006-27.3Z"
    />
  </svg>
)
export default SvgComponent
